import API from 'aurora-api';
import * as urls from 'aurora-api/urls';
import { ACTIVE_URL } from 'aurora-utils/constants';

const { BASE_URL } = ACTIVE_URL;

const api = new API(BASE_URL);
const downloadAPI = new API(BASE_URL, null, {
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
  },
  responseType: 'blob',
});
class DeveloperServices {
  static fetchPropertyProjects = query => api.get(urls.DEVELOPER.PROJECTS, null, query);

  static fetchEscrowPropertyProjects = (query, params) =>
    api.post(urls.DEVELOPER.ESCROW_PROJECTS, { ...query }, params);

  static fetchPropertyProjectById = id => api.get(urls.DEVELOPER.PROJECT_BY_PROJECT_INFORMATION, id);

  static fetchProjectByFinancialSummary = id => api.get(urls.DEVELOPER.PROJECT_BY_FINANCIAL_SUMMARY, id);

  static fetchProjectByFinancialTransaction = id => api.get(urls.DEVELOPER.PROJECT_BY_FINANCIAL_TRANSACTION, id);

  static fetchProjectByProgressReport = id => api.get(urls.DEVELOPER.PROJECT_BY_PROGRESS_REPORT, id);

  static fetchProjectByLatestProgressReport = id =>
    api.get(`${urls.DEVELOPER.PROJECT_BY_PROGRESS_REPORT}/${id}/latest`);

  static fetchProjectByServiceCharges = id =>
    api.get(`${urls.DEVELOPER.PROJECT_BY_SERVICE_CHARGES}/${id}/group/latest`);

  static fetchProjectByServiceChargesGroups = id => api.get(`${urls.DEVELOPER.PROJECT_BY_SERVICE_CHARGES}/${id}/group`);

  static fetchProjectByServiceChargesGroupData = (id, groupId) =>
    api.get(`${urls.DEVELOPER.PROJECT_BY_SERVICE_CHARGES}/${id}/group/${groupId}`);

  static fetchProjectUnits = id => api.get(urls.DEVELOPER.PROJECT_UNITS, id);

  static downloadTransaction = appId => api.get(urls.DEVELOPER.PROJECT_TRANSACTION_DOWNLOAD, appId);

  static downloadCertificate = appId => downloadAPI.get(urls.DEVELOPER.CERTIFICATE_DOWNLOAD, appId);
}

export default DeveloperServices;
